import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLandingSparkle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 3C17.08 11.52 20.48 14.92 29 16C20.48 17.08 17.08 20.48 16 29C14.92 20.48 11.52 17.08 3 16C11.52 14.92 14.92 11.52 16 3Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.25
	})
});
export default SvgLandingSparkle;
